import { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

import authAxios from "../../components/authAxios";

// import { Link } from "react-router-dom";
import Pagination from '@mui/material/Pagination';

import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import DashboardHeader from "../../components/DashboardHeader";
import { useMediaQuery } from 'react-responsive'
import { Card, CardContent } from "@mui/material";

import ThreeDotsMenu from "../../components/ThreeDotsMenu";
import ContactNew from "../../components/ContactNew";

const Guarantors = () => {
    const isMobile = useMediaQuery({ query: '(max-width: 750px)' })
    const [page, setPage] = useState(1);
    const [pagecount, setPageCount] = useState();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const tag = "GUARANTOR"

    const { data: guarantors } = useQuery({
        queryKey: ['guarantors', page],
        queryFn: async () => {
          const response = await authAxios.get(`/loans/guarantors/?page=${page}`);
          setPageCount(response.data.page_count)
          return response.data.results
        },
        // keepPreviousData : true,
    });

    const { data: clientProfile } = useQuery({
        queryKey: ['clientProfile'],
        queryFn: async () => {
          const response = await authAxios.get(`/clientprofiles/${localStorage.getItem('clientProfile')}`);
          return response.data
        },
    });

    const handlePageChange = (event, value) => {
        setPage(value);
    };

     const threeSubMenu = [
        {
            id: 1,
            menu: "View",
            url: "/dashboard/customer/",

        }, 
        // {
        //     id: 2,
        //     menu: "Edit",
        //     url: "/dashboard/customeredit/",
        // }
    ];   

    return (
            <div className="dashboard-main">
                <section className="dashboard-content">
                    <DashboardHeader dashboardTitle="Guarantors" dashboardPreTitle="CRM" />

                    <table className="styled-table">
                        <thead>
                            <tr >
                                <th>ID</th>
                                <th>Name</th>
                                <th>Telephone</th>
                                <th>Loans Guaranteed</th>
                                <th className="cell-align-right">Amount Guaranteed</th>
                                <th></th>
                            </tr>
                        </thead>

                        {guarantors && guarantors.map(guarantor => (

                            <tbody key={guarantor.id}>
                                <tr>
                                    <td>{guarantor.id}</td>
                                    <td>{guarantor.name}</td>
                                    <td>{guarantor.telephone}</td>
                                    <td>{guarantor.loans_guaranteed}</td>
                                    {clientProfile && clientProfile.currency_code? 
                                        <td className="cell-align-right">{Number(guarantor.amount_guaranteed).toLocaleString('en-UK', { style: 'currency', currency: clientProfile.currency_code })}</td>
                                        :
                                        <td>{Number(guarantor.amount_guaranteed).toLocaleString('en-UK')}</td>
                                    }
                                    <td className='styled-table-menu'>
                                        <ThreeDotsMenu data={guarantor} threeSubMenu={threeSubMenu} />
                                    </td>
                                </tr>
                            </tbody>
                        ))}
                        

                    </table>
                    
                    <ContactNew 
                        isModalOpen={isModalOpen}
                        setIsModalOpen={setIsModalOpen}
                        tag={tag}
                    />

                    <Pagination 
                        className="custom-mui-pagination"
                        count={pagecount} 
                        page={page} 
                        onChange={handlePageChange} 
                    />

                    {/* <Fab className="fab" color="primary" aria-label="add" onClick={()=>{
                        setIsModalOpen(true)}}
                        >
                        <AddIcon />
                    </Fab> */}
                </section>
            </div>

    )
}
export default Guarantors